import React from 'react';
import styled, { css } from 'styled-components';

import { useMedia } from '@tager/web-core';

import MoreDetailsAuto from '@/assets/svg/detailed-car/more-details-auto.svg';
import { DetailedCarMoreDetailsProps } from '@/components/DetailedCarMoreDetails/DetailedCarMoreDetails.types';
import MoreDetailsMobileCollapse from '@/components/DetailedCarMoreDetails/components/MoreDetailsMobileCollapse';
import { media } from '@/utils/mixin';

function DetailedCarMoreDetails({ text }: DetailedCarMoreDetailsProps) {
  const isMobile = useMedia('(max-width: 767px)');

  return (
    <Component>
      <SvgWrapper>
        <MoreDetailsAuto />
      </SvgWrapper>
      <Content>
        <ContentTitle>Подробнее об авто</ContentTitle>
        {isMobile ? (
          <MoreDetailsMobileCollapse text={text} />
        ) : (
          <ContentText
            dangerouslySetInnerHTML={{
              __html: text.split('\n').join('<br><br>'),
            }}
          />
        )}
      </Content>
    </Component>
  );
}

export default DetailedCarMoreDetails;

const Component = styled.div`
  display: flex;
  padding: 50px;
  background: ${(props) => props.theme.white_1};
  border: 1px solid ${(props) => props.theme.gray1700};
  border-radius: 8px;

  ${media.mobile(
    css`
      padding: 20px 15px;
    `
  )}
`;

const SvgWrapper = styled.div`
  flex: 0 0 98px;
  height: 98px;
  margin-right: 50px;

  svg {
    width: 100%;
    height: 100%;
  }

  ${media.mobile(
    css`
      display: none;
    `
  )}
`;
const Content = styled.div`
  flex: 1;
`;

const ContentTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
  color: ${(props) => props.theme.black};

  ${media.mobile(
    css`
      text-align: center;
    `
  )}
`;

const ContentText = styled.div`
  font-size: 18px;
  font-weight: 300;
  color: ${(props) => props.theme.black};
`;
